import ProductDescription from './ProductDescription'

const BulgurProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '004',
  IsBroadband: true,
  GrainSize: '16 ounces only',
  Organic: false,
}

export default BulgurProduct
